import AssessmentResultContainer from './assessment_result_container';

const AssessmentResult = AssessmentResultContainer;
export default AssessmentResult;
